import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import SectorsPage from './pages/SectorsPage';
import ServicesPage from './pages/ServicesPage';
import ContactPage from './pages/ContactPage';
import SingleSectorPage from './pages/SingleSectorPage';
import AnnouncementsPage from "./pages/AnnouncementsPage";
import PlatformsPage from "./pages/PlatformsPage";
import './App.css';
import NewsBarPage from "./components/NewsBarPage";
import ScrollToTop from "./components/ScrollToTop";

const App = () => {
  return (
    <Router>
        <ScrollToTop /> {/* Bunu buraya ekle */}

      <div className="app">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/sectors" element={<SectorsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/sector/:sectorId" element={<SingleSectorPage />} />
            <Route path="/announcements" element={<AnnouncementsPage />} />
            <Route path="/platforms" element={<PlatformsPage />} />
                    <Route path="/haberler" element={<NewsBarPage />} />

          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
